import PropTypes from 'prop-types';
import { memo } from 'react';
import sanitizeHtml from 'sanitize-html';

import Scrollbars from 'components/ScrollBar';
import FileList from 'containers/components/FileList';
import '../styles.scss';

const propTypes = {
    model: PropTypes.object.isRequired,
    calculatedOffsetHeight: PropTypes.number,
};

const PrimaryPanelInformation = memo(({ model, calculatedOffsetHeight }) => {
    let files = model.attachmentFiles;

    return (
        <div
            className="panel-primary-information"
            style={{
                height: calculatedOffsetHeight ? `calc(100% - ${calculatedOffsetHeight}px` : '100%',
            }}
        >
            <Scrollbars autoHide={true}>
                <FileList files={files} />
                <div
                    className="ql-editor billboard-description"
                    dangerouslySetInnerHTML={{ __html: sanitizeHtml(model.description) }}
                />
            </Scrollbars>
        </div>
    );
});

PrimaryPanelInformation.propTypes = propTypes;

export default PrimaryPanelInformation;
